@if (true) {
<ng-container *ifSize="'XL'">
    <div [ngClass]="[component.bg_color || '', !component.autoScroll ? 'flex flex-justify-center' : '']">
        @switch (component.autoScroll) {
        @case (true) {
        <div class="flex flex-middle container">
            @for (i of [].constructor(10); track $index) {
            <div class="flex flex-middle flex-justify-between _scrolling"
                 [style.animationDuration]="component.animationDuration + 's'"
                 [attr.aria-hidden]="!$first">
                @for (item of component.trust_messages; track item) {
                <ng-container
                              *ngTemplateOutlet="displayContentXL; context: { component: component, item : item }"></ng-container>
                }
            </div>
            }
        </div>
        }
        @default {
        @for (item of component.trust_messages | slice: 0 : 5; track item) {
        <ng-container
                      *ngTemplateOutlet="displayContentXL; context: { component: component, item : item }"></ng-container>
        }
        }
        }
    </div>
</ng-container>

<ng-container *ifSize="'SM'">
    @switch (component.autoScroll) {
    @case (true) {
    <div class="flex flex-middle container p-t-2 p-b-2"
         [ngClass]="component.bg_color || ''">
        @for (i of [].constructor(10); track $index) {
        <div class="flex flex-middle _scrolling"
             [style.animationDuration]="component.animationDuration + 's'"
             [attr.aria-hidden]="!$first">
            @for (item of component.trust_messages; track item) {
            <ng-container
                          *ngTemplateOutlet="displayContentSM; context: { component: component, item : item }"></ng-container>
            }
        </div>
        }
    </div>
    }
    @default {
    <carousel class="wrap-m p-a-10 p-l-20-m p-r-20-m p-b-16 p-b-20-m bg-col-5"
              [ngClass]="component.bg_color || ''"
              [slidesPerView]="1"
              [navigation]="false"
              [spaceBetween]="20"
              [scrollbar]="false"
              [pagination]="true"
              [loop]="client.isS || client.isM">
        @for (item of component.trust_messages; track item) {
        <ng-template swiperSlide>
            <ng-container
                          *ngTemplateOutlet="displayContentSM; context: { component: component, item : item }"></ng-container>
        </ng-template>
        }
    </carousel>
    }
    }
</ng-container>

<ng-template #displayContentXL
             let-item="item"
             let-component="component">
    <div class="flex flex-column flex-justify-top w-2 m-r m-l p-t-8 p-b-8"
         [ngClass]="[component.reducePaddingOnX ? 'p-l-1-x p-r-1-x' : 'p-l-16-x p-r-16-x',
                           component.reducePaddingOnL ? 'p-l-1 p-r-1' : 'p-l-6 p-r-6']">
        <href [link]="item.url">
            <div class="flex flex-column flex-middle">
                <div class="overflow-hidden"
                     style="min-height: 55px"
                     [ngClass]="[item.ratio || '', item.image_padding_right || '', item.image_padding_left || '' ]">
                    @if(component.bg_color !== 'bg-col-t') {
                    <local-shell />
                    }
                    <div class="fill"
                         [ngClass]="component.bg_color || ''">
                        <img class="rf"
                             [image]="item.image">
                    </div>
                </div>
                <span class="center m-t-3 inline-block"
                      [ngClass]="[item.color || '', item.msg_font_style || '']"
                      *iCms="'text' of item; content: 'html'"></span>
            </div>
        </href>
    </div>
</ng-template>

<ng-template #displayContentSM
             let-item="item"
             let-component="component">
    <div class="p-l-10 p-r-10 p-l-20-m p-r-20-m center">
        <href [link]="item.url">
            <div class="flex flex-column flex-middle">
                <div class="overflow-hidden"
                     style="min-height: 65px"
                     [ngClass]="item.ratio || ''">
                    @if(component.bg_color !== 'bg-col-t') {
                    <local-shell />
                    }
                    <div class="fill"
                         [ngClass]="component.bg_color || ''">
                        <img class="rf"
                             [image]="item.image">
                    </div>
                </div>
            </div>
        </href>

        <span class="ta-center m-t-3 inline-block"
              [ngClass]="[item.color || '', item.msg_font_style || '']"
              *iCms="'text' of item; content: 'html'"></span>
    </div>
</ng-template>
}
